!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, o = {}, n = t.parcelRequire5f74;
  null == n && ((n = function(t) {
    if (t in e) return e[t].exports;
    if (t in o) {
      var n = o[t];
      delete o[t];
      var i = {
        id: t,
        exports: {}
      };
      return e[t] = i, n.call(i.exports, i, i.exports), i.exports;
    }
    var a = new Error("Cannot find module '" + t + "'");
    throw a.code = "MODULE_NOT_FOUND", a;
  }).register = function(t, e) {
    o[t] = e;
  }, t.parcelRequire5f74 = n), (0, n.register)("kmbQD", function(t, e) {
    var o, n, i, a;
    o = t.exports, n = "default", i = function() {
      return r;
    }, Object.defineProperty(o, n, {
      get: i,
      set: a,
      enumerable: !0,
      configurable: !0
    });
    class r {
      static doChange({id: t, quantity: e, properties: o = {}}, n = !1) {
        return fetch(`${Shopify.routes.root || "/"}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            id: t,
            quantity: e,
            properties: {
              ...o
            }
          })
        }).then(t => {
          if (!t.ok) throw new Error("Cart change failed");
          return t.ok && n && this.update(!0), t;
        }).catch(t => t);
      }
      static doUpdate(t, e, o = !1) {
        const n = Array.isArray(t) ? t.reduce((t, o) => ({
          ...t,
          [o]: e
        }), {}) : {
          id: e
        };
        return fetch(`${Shopify.routes.root || "/"}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            updates: n
          })
        }).then(t => {
          if (!t.ok) throw new Error("Cart update failed");
          return t.ok && o && this.update(!0), t;
        }).catch(t => t);
      }
      static doAdd({id: t, quantity: e, properties: o = {}}, n = !1, i = !0) {
        return fetch(`${Shopify.routes.root || "/"}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            items: [ {
              id: t,
              quantity: e,
              properties: {
                ...o
              }
            } ]
          })
        }).then(e => {
          if (!e.ok) throw new Error("Cart add failed");
          return e.ok && i ? (window.dispatchEvent(new CustomEvent("product:added", {
            detail: {
              variantId: t
            }
          })), e) : e.ok && n ? (this.update(!0), e) : void 0;
        }).catch(t => t);
      }
      static getCart() {
        return fetch(`${Shopify.routes.root || "/"}cart.js`, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        }).then(t => {
          if (!t.ok) throw new Error("Failed to fetch cart");
          return t;
        }).catch(t => t);
      }
      static cleanupTeleportedContent() {
        document.querySelectorAll("[data-teleport-origin]").forEach(t => {
          t.remove();
        });
      }
      static update(t = !1, e = "cart-drawer", o = null) {
        try {
          e = e.replace("cart-drawer", document.querySelector("cart-drawer").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        try {
          e = e.replace("cart-notification", document.querySelector("cart-notification").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        (e = e.split(",")).push("header"), e = [ ...new Set(e) ];
        const n = document.getElementById("Cart"), i = !!t || n && n.checked;
        return fetch(`${location.pathname}?sections=${e.join(",")}`, {
          method: "GET"
        }).then(t => t.json()).then(t => {
          this.cleanupTeleportedContent(), Object.entries(t).forEach(t => {
            const [e, n] = t, a = (new DOMParser).parseFromString(n, "text/html");
            if (e.includes("cart-notification")) {
              const t = document.querySelector("cart-notification"), e = a.querySelector("cart-notification");
              t && e && (t.innerHTML = e.innerHTML);
            }
            o ??= [ `[id^="shopify-section-"][id$="${e}"]` ], o.push("header [data-cart-count-desktop]", "header [data-cart-count-mobile]", "form [data-cart-count]", "[data-cart-link]"), 
            o.forEach(t => {
              document.querySelectorAll(t).forEach(e => {
                const o = a.querySelector(t);
                o && (e.innerHTML = i ? o.innerHTML.replace('id="Cart"', 'id="Cart" checked') : o.innerHTML);
              });
            });
          });
        });
      }
    }
  });
  var i = n("kmbQD");
  class a extends HTMLElement {
    constructor() {
      super(), this.toggle = document.getElementById("CartNotification");
    }
    connectedCallback() {
      window.addEventListener("product:added", this.handleProductAdded.bind(this)), document.addEventListener("swym:addedtocart", this.handleSwymAddedToCart.bind(this)), 
      this.addEventListener("click", t => {
        t.target.matches("[data-view-cart]") && this.openCartDrawer();
      }), this.toggle && this.toggle.addEventListener("change", t => {
        t.target.checked || document.body.classList.remove("cart-notification-open");
      });
    }
    disconnectedCallback() {
      window.removeEventListener("product:added", this.handleProductAdded.bind(this)), 
      document.removeEventListener("swym:addedtocart", this.handleSwymAddedToCart.bind(this));
    }
    handleProductAdded(t) {
      const {variantId: e} = t.detail;
      i.default.update(!1, "cart-drawer,cart-notification").then(() => {
        setTimeout(() => {
          this.showSpecificItem(e), this.show();
        }, 100);
      }).catch(t => {
        console.warn(t);
      });
    }
    handleSwymAddedToCart(t) {
      console.log("CartNotification: Item added to cart from wishlist via Swym:", t.detail);
      const e = t.detail;
      let o = null, n = 1;
      console.log({
        swymDetail: e
      }), e && e.d.productData && e.d.productData.id && (o = e.d.productData.id.toString(), 
      e.quantity && (n = parseInt(e.quantity))), o ? window.dispatchEvent(new CustomEvent("product:added", {
        detail: {
          variantId: o
        }
      })) : console.warn("CartNotification: Could not extract variant ID from Swym event:", e);
    }
    showSpecificItem(t) {
      this.querySelectorAll("[data-item-id]").forEach(t => {
        t.classList.add("hidden"), t.classList.remove("grid");
      });
      const e = this.querySelector(`[data-item-id="${t}"]`);
      e && (e.classList.remove("hidden"), e.classList.add("grid"));
    }
    show() {
      this.toggle && (document.body.classList.add("cart-notification-open"), this.toggle.checked = !0, 
      this.toggle.dispatchEvent(new Event("change")));
    }
    hide() {
      this.toggle && (document.body.classList.remove("cart-notification-open"), this.toggle.checked = !1, 
      this.toggle.dispatchEvent(new Event("change")));
    }
    openCartDrawer() {
      const t = document.getElementById("Cart");
      this.hide(), t && (t.checked = !0, t.dispatchEvent(new Event("change")));
    }
  }
  customElements.get("cart-notification") || customElements.define("cart-notification", a);
}();